import classNames from 'classnames';
import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'store';

import { searchString } from 'services/search/searchToStr';

import Container from 'components/Container';
import SearchBox from 'components/SearchBox';
import Section from 'components/Section';
import Text from 'components/Text';

import { useSearch } from 'store/hooks/useSearch';
import { selectBrowser } from 'store/slices/browser';
import { selectSearchId } from 'store/slices/search';
import { selectArrival, selectDeparture } from 'store/slices/searchBox';

const SearchDetailsBar = ({ className }) => {
    const [formOpen, toggleForm] = useState(true);
    const searchId = useSelector(selectSearchId);
    const browser = useSelector(selectBrowser);
    const arrival = useSelector(selectArrival);
    const departure = useSelector(selectDeparture);

    const { search, isSuccess } = useSearch();

    useEffect(() => {
        if (searchId) {
            toggleForm(false);
        }
    }, [searchId]);

    return isSuccess ? (
        <div className={classNames(className, { 'no-search': !searchId })}>
            <Section type="lightBlue">
                <Container>
                    <div className="inner">
                        {searchId && (
                            <div className="search-details">
                                <Text margin="0">
                                    {browser.size !== 'xs' ? (
                                        `Prices shown for a total of ${departure.diff(
                                            arrival,
                                            'days',
                                        )} nights from ${arrival.format(
                                            'Do MMMM YYYY',
                                        )} - ${departure.format(
                                            'Do MMMM YYYY',
                                        )} for ${searchString(
                                            search.occupancy.rooms,
                                        )}`
                                    ) : (
                                        <>
                                            {`${arrival.format(
                                                'Do MMM YYYY',
                                            )} - ${departure.format(
                                                'Do MMM YYYY',
                                            )}`}
                                            <br />
                                            {`${searchString(
                                                search.occupancy.rooms,
                                            )}`}
                                        </>
                                    )}
                                </Text>
                                <span
                                    className="change-search-trigger"
                                    onClick={() => {
                                        toggleForm(!formOpen);
                                    }}
                                >
                                    {browser.size !== 'xs'
                                        ? 'Change Search'
                                        : 'Change'}
                                </span>
                            </div>
                        )}
                        <div
                            className={classNames({
                                'search-box-container': true,
                                'search-box-container--open': formOpen,
                            })}
                        >
                            <SearchBox
                                type={
                                    ['xs', 'sm'].includes(browser.size)
                                        ? 'vertical'
                                        : 'horizontal'
                                }
                            />
                        </div>
                    </div>
                </Container>
            </Section>
        </div>
    ) : null;
};

export default SearchDetailsBar;
